/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Calendar } from './Calendar';
import type { UserGoal } from './UserGoal';
/**
 * 
 * @export
 * @interface YearWeek
 */
export interface YearWeek {
    /**
     * 
     * @type {number}
     * @memberof YearWeek
     */
    id?: number;
    /**
     * 
     * @type {Array<Calendar>}
     * @memberof YearWeek
     */
    calendars?: Array<Calendar> | null;
    /**
     * 
     * @type {Array<UserGoal>}
     * @memberof YearWeek
     */
    userGoals?: Array<UserGoal> | null;
}

/**
 * Check if a given object implements the YearWeek interface.
 */
export function instanceOfYearWeek(value: object): value is YearWeek {
    return true;
}

export function YearWeekFromJSON(json: any): YearWeek {
    return YearWeekFromJSONTyped(json, false);
}

export function YearWeekFromJSONTyped(json: any, ignoreDiscriminator: boolean): YearWeek {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'calendars': json['calendars'] == null ? undefined : ((json['calendars'] as Array<any>).map((require('./Calendar') as typeof import('./Calendar')).CalendarFromJSON)),
        'userGoals': json['userGoals'] == null ? undefined : ((json['userGoals'] as Array<any>).map((require('./UserGoal') as typeof import('./UserGoal')).UserGoalFromJSON)),
    };
}

export function YearWeekToJSON(json: any): YearWeek {
    return YearWeekToJSONTyped(json, false);
}

export function YearWeekToJSONTyped(value?: YearWeek | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'calendars': value['calendars'] == null ? undefined : ((value['calendars'] as Array<any>).map((require('./Calendar') as typeof import('./Calendar')).CalendarToJSON)),
        'userGoals': value['userGoals'] == null ? undefined : ((value['userGoals'] as Array<any>).map((require('./UserGoal') as typeof import('./UserGoal')).UserGoalToJSON)),
    };
}

